"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Place_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Place = void 0;
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const schema_1 = require("../ontologies/schema");
const Thing_1 = require("./Thing");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
let Place = Place_1 = class Place extends Thing_1.Thing {
    get latitude() {
        return this.getValue(schema_1.schema.latitude);
    }
    set latitude(val) {
        this.overwrite(schema_1.schema.latitude, new models_1.Literal(val));
    }
    get longitude() {
        return this.getValue(schema_1.schema.longitude);
    }
    set longitude(val) {
        this.overwrite(schema_1.schema.longitude, new models_1.Literal(val));
    }
    get containedInPlace() {
        return this.getOneAs(schema_1.schema.containedInPlace, Place_1);
    }
    set containedInPlace(val) {
        this.overwrite(schema_1.schema.containedInPlace, val.namedNode);
    }
};
Place.targetClass = schema_1.schema.Place;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.latitude,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Place.prototype, "latitude", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.longitude,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Place.prototype, "longitude", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.containedInPlace,
        shape: Place_1,
    }),
    __metadata("design:type", Place),
    __metadata("design:paramtypes", [Place])
], Place.prototype, "containedInPlace", null);
Place = Place_1 = __decorate([
    package_1.linkedShape
], Place);
exports.Place = Place;
//# sourceMappingURL=Place.js.map